import React from 'react';
import { CheckIcon } from 'lucide-react';
export function FinancingSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-2617">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2618">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-12 text-center" data-id="element-2619">
          Machine Tool Financing Options
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-2620">
          <div className="bg-gray-50 rounded-lg p-8 border-2 border-gray-200" data-id="element-2621">
            <div className="w-full h-20 flex items-center justify-center mb-6" data-id="element-2622">
              <img src="https://cdn.magicpatterns.com/uploads/qwEUwx9bjcUUAmRoX3tEuj/US-Bank.png" alt="U.S. Bank logo" className="block max-h-20 max-w-full w-auto h-auto object-contain" data-id="element-2623" />
            </div>
            <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-2624">
              U.S. Bank Financing
            </h3>
            <ul className="space-y-3" data-id="element-2625">
              <li className="flex items-start" data-id="element-2626">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-2627" />
                <span className="text-gray-700" data-id="element-2628">100% Financing</span>
              </li>
              <li className="flex items-start" data-id="element-2629">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-2630" />
                <span className="text-gray-700" data-id="element-2631">
                  Competitive Rates Flexible Payments
                </span>
              </li>
              <li className="flex items-start" data-id="element-2632">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-2633" />
                <span className="text-gray-700" data-id="element-2634">Quick and Easy Process</span>
              </li>
              <li className="flex items-start" data-id="element-2635">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-2636" />
                <span className="text-gray-700" data-id="element-2637">
                  Convenient one-page application up to $500,000
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 rounded-lg p-8 border-2 border-gray-200" data-id="element-2638">
            <div className="w-full h-20 flex items-center justify-center mb-6" data-id="element-2639">
              <img src="https://cdn.magicpatterns.com/uploads/6BfRo1TbqCirwbTzFfqsr4/Banterra_Machine_Tool_Financing.jpg" alt="Banterra Machine Tool Finance logo" className="block max-h-20 max-w-full w-auto h-auto object-contain" data-id="element-2640" />
            </div>
            <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-2641">
              Banterra Machine Tool Finance
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-2642">
              <li className="flex items-start" data-id="element-2643">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-2644" />
                <span className="text-gray-700" data-id="element-2645">
                  Fixed, simple interest rate loans (no leases)
                </span>
              </li>
              <li className="flex items-start" data-id="element-2646">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-2647" />
                <span className="text-gray-700" data-id="element-2648">
                  Ability to make additional payments to principal at any time
                  (saves interest)
                </span>
              </li>
              <li className="flex items-start" data-id="element-2649">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-2650" />
                <span className="text-gray-700" data-id="element-2651">
                  Ability to pay off WITHOUT penalty at any time
                </span>
              </li>
            </ul>
            <p className="text-sm text-gray-600" data-id="element-2652">www.banterramachinetool.com</p>
          </div>
        </div>
      </div>
    </section>;
}